import { ssoLogin, refreshToken, getDetailByAccountOrId } from '@/api/user'
import { resetRouter } from '@/router'
import sso from '@/sso'
import {
  DEFAULT_LANGUAGE,
  handleLang,
} from '@transsion/hotent-ui/packages/Language'
import { loadLanguageAsync } from '@/i18n'

let refreshTokensInflight = null

const state = () => ({
  username: '',
  avatar: '',
  userId: '',
  account: '',
  token: '',
  rtoken: '',
  userInfo: {},
  isAdmin: undefined,
  permissions: [],
})
const getters = {
  userId: (state) => state.userId,
  username: (state) => state.username,
  account: (state) => state.account,
  avatar: (state) => state.avatar,
  userInfo: (state) => state.userInfo,
  tokens: (state) => ({ token: state.token, rtoken: state.rtoken }),
  permissions: (state) => state.permissions,
  orgId: (state) =>
    Array.isArray(state.userInfo.org) ? state.userInfo.org[0]?.orgId || '' : '',
  isAdmin: (state) => state.isAdmin,
}
const mutations = {
  setAvatar(state, avatar) {
    state.avatar = avatar
  },
  setUserinfo(state, userInfo) {
    const { username, userId, account } = userInfo

    state.username = username
    state.userId = userId
    state.account = account
  },
  clearUserinfo(state) {
    state.username = ''
    state.userId = ''
    state.account = ''
  },
  setUserDetailInfo(state, userInfo) {
    state.userInfo = userInfo
  },
  setAdmin(state, admin) {
    if (typeof admin === 'string') {
      switch (admin) {
        case 'true':
          admin = true
          break
        case 'false':
          admin = false
          break
        default:
          admin = false
      }
    }
    state.isAdmin = admin
  },
  setTokens(state, payload) {
    state.token = payload.token
    state.rtoken = payload.rtoken

    sso.storage.setRtoken(payload.token)
    sso.storage.setUtoken(payload.rtoken)
  },
  clearTokens(state) {
    state.token = ''
    state.rtoken = ''

    sso.storage.clear()
  },
}
function getLocalUser(rtoken) {
  const tokenUserStr = localStorage.getItem('tr_token_user')
  if (tokenUserStr) {
    const userMap = JSON.parse(tokenUserStr)
    return userMap[rtoken]
  } else {
    return null
  }
}
function setLocalUser(rtoken, userInfo) {
  let val = null
  if (userInfo) {
    val = JSON.stringify({ [rtoken]: userInfo })
  }
  localStorage.setItem('tr_token_user', val)
}
const actions = {
  async refreshTokens({ commit, state }) {
    if (refreshTokensInflight) return refreshTokensInflight

    const currentToken = state.token || sso.storage.getRtoken()
    const currentRtoken = state.rtoken || sso.storage.getUtoken()

    // 没有登录态时不刷新
    if (!currentToken || !currentRtoken) return

    refreshTokensInflight = (async () => {
      // 正常走请求拦截器，header 里携带 P-Auth/P-RToken
      const resp = await refreshToken()
      const nextToken = resp && resp['p-auth']
      const nextRtoken = resp && resp['p-rtoken']

      if (nextToken && nextRtoken) {
        commit('setTokens', { token: nextToken, rtoken: nextRtoken })
      }
    })()

    try {
      return await refreshTokensInflight
    } finally {
      refreshTokensInflight = null
    }
  },
  getUserDataScopes({ state }) {
    try {
      const { dataScopes } = state.userInfo
      if (Array.isArray(dataScopes)) {
        const dataScopeCodes = dataScopes
          .map((scope) => scope.dataScopeCode)
          .join(',')
        return dataScopeCodes
      }
    } catch (error) {
      console.error(error)
    }
  },
  // 单点登录
  async ssoLogin({ commit, dispatch }, url) {
    let payload = sso.auth.parseLoginPayload(url)

    if (!payload || !payload.token || !payload.rtoken) {
      const token = sso.storage.getRtoken()
      const rtoken = sso.storage.getUtoken()
      if (token && rtoken) {
        const copyPayload = payload ? { ...payload } : {}
        payload = { ...copyPayload, token, rtoken }
      } else {
        throw new Error('无法获取登录信息')
      }
    }

    // 初始化语言
    let lang = payload.lang ?? localStorage.getItem('lang') ?? DEFAULT_LANGUAGE
    lang = handleLang(lang)
    await loadLanguageAsync(lang)
    localStorage.setItem('lang', lang)

    // 先从本地获取user信息，若没有则从远端获取。
    const localUser = getLocalUser(payload.rtoken)

    if (localUser) {
      commit('setTokens', payload)
      commit('setUserinfo', localUser)
    } else {
      const { rtoken, utoken, ...userInfo } = await ssoLogin(payload)

      if (rtoken !== payload.token) {
        payload.token = rtoken
        payload.rtoken = utoken
      }

      commit('setTokens', payload)
      commit('setUserinfo', userInfo)
      setLocalUser(utoken, userInfo)
      await dispatch('getUserDetail')
    }
  },
  cleanLoginPayload(_, url) {
    return sso.auth.cleanLoginPayload(url)
  },
  toLoginUrl(_, redirect) {
    const urlParams = new URLSearchParams(window.location.search)
    const account = urlParams.get('account')

    const loginUrl = sso.auth.getLoginUrl(redirect || window.location.href)

    window.location.href = loginUrl + (account ? `&account=${account}` : '')
  },
  getUserDetail({ commit, state }) {
    let account = state.account
    if (!Object.keys(state.userInfo).length && account) {
      return new Promise((resolve) => {
        getDetailByAccountOrId(account).then((res) => {
          console.log(res)
          commit('setUserDetailInfo', res)
          commit('setAvatar', res.user.photo)
          commit('setAdmin', res.user.admin)
          resolve(res)
        })
      })
    }
  },
  async logout() {
    sessionStorage.removeItem('currentPostId')
    sso.storage.clear()
    await resetRouter()
  },
}
export default { state, getters, mutations, actions }
